import { useState, useEffect } from 'react';
import { API_ENDPOINTS } from '../config/api-endpoints';
import { User, Course, Progress } from '../types';
import authService from '../services/authService';
import { useQuery } from '@tanstack/react-query';

export function useCourseDetails(token ?: string, courseId ?: string) {
  return useQuery({
    queryKey : ['courseDetails', courseId],
    queryFn : async () => {
      const baseURL = process.env.REACT_APP_API_URL || 'https://eft-assured-early.ngrok-free.app/api';
      const url = `${baseURL}${API_ENDPOINTS.GET_COURSE_BY_ID(courseId || '')}`;
      
      const res: any = await (await fetch(url, {
        method : 'GET',
        headers : {
          'Content-Type' : 'application/json',
          'Authorization': `Bearer ${authService.getToken()}`,
        },
      })).json();
      
      if (res.error) {
        throw new Error('Failed to fetch course details');
      }
      console.log('Course Details:', res.data);
      return res.data as any;
    },
    enabled: !!courseId,
  })
};

export function useCourseLessons(token ?: string, courseId ?: string) {
  return useQuery({
    queryKey : ['courseLessons', courseId],
    queryFn : async () => {
      const baseURL = process.env.REACT_APP_API_URL || 'https://eft-assured-early.ngrok-free.app/api';
      const url = `${baseURL}${API_ENDPOINTS.GET_LESSONS_BY_COURSEID(courseId || '')}`;
      
      const res: any = await (await fetch(url, {
        method : 'GET',
        headers : {
          'Content-Type' : 'application/json',
          'Authorization': `Bearer ${authService.getToken()}`,
        },
      })).json();
      
      if (res.error) {
        throw new Error('Failed to fetch course lessons');
      }
      console.log('Course Lessons:', res.data);
      return res.data as any;
    },
    enabled: !!courseId,
    })
}

export function useCourseList(token ?: string) {
  return useQuery({
    queryKey : ['courseList'],
    queryFn : async () => {
      const baseURL = process.env.REACT_APP_API_URL || 'https://eft-assured-early.ngrok-free.app/api';
      const url = `${baseURL}${API_ENDPOINTS.GET_COURSES}`;
      
      const res: any = await (await fetch(url, {
        method : 'GET',
        headers : {
          'Content-Type' : 'application/json',
        //   'Authorization': `Bearer ${authService.getToken()}`,
        },
      })).json();
      
      if (res.error) {
        throw new Error('Failed to fetch course list');
      }
      console.log('Course List:', res.data);
      return res.data as any;
    },
    enabled: true,
  })
}
